// removed by extract-text-webpack-plugin
module.exports = {"container":"_3RjCYUGwnkM7aOMV7GMo-I","details":"_3M0EUIftpVzJ1r8ah5lbJn","toggle":"_3NMBuy5GjDIotNe3HHzon2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/profileDropdown/styles.css
// module id = 1090
// module chunks = 0